import { createContext } from 'react'

import type { BrandCategoryPageDesktopContextData } from './types'

export const BrandCategoryPageDesktopContext = createContext<BrandCategoryPageDesktopContextData | null>(null)
